import type { Breakpoint, SxProps, Theme } from "@mui/material/styles";

import { Alert, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { AboutIcon } from "src/Version/components/AboutIcon";
import { AccountPopover } from "User/components/account/AccountPopover";
import { NotificationsPopover } from "User/components/notification/NotificationsPopover";

import { HeaderSection } from "../components/HeaderSection";
import { LayoutContent } from "../components/LayoutContent";
import { LayoutSection } from "../components/LayoutSection";
import { layoutClasses } from "../settings";
import { NavigationMobile } from "./components/navigation/components/NavigationMobile";
import { NavigationWidescreen } from "./components/navigation/components/NavigationWidescreen";

export type MainLayoutProps = {
  children: React.ReactNode;
  header?: {
    sx?: SxProps<Theme>;
  };
  sx?: SxProps<Theme>;
};

export const MainLayout = ({ children, header, sx }: MainLayoutProps) => {
  const theme = useTheme();

  const layoutQuery: Breakpoint = "lg";

  return (
    <LayoutSection
      cssVars={{
        "--layout-dashboard-content-pb": theme.spacing(8),
        "--layout-dashboard-content-pt": theme.spacing(1),
        "--layout-dashboard-content-px": theme.spacing(5),
        "--layout-nav-vertical-width": "300px",
      }}
      footerSection={null}
      headerSection={
        <HeaderSection
          layoutQuery={layoutQuery}
          slotProps={{
            container: {
              maxWidth: false,
              sx: { px: { [layoutQuery]: 5 } },
            },
          }}
          slots={{
            leftArea: <NavigationMobile breakpointTo={layoutQuery} />,
            rightArea: (
              <Box alignItems="center" display="flex" gap={1}>
                <AboutIcon />
                <NotificationsPopover />
                <AccountPopover />
              </Box>
            ),
            topArea: (
              <Alert severity="error" sx={{ borderRadius: 0, display: "none" }}>
                This is an info Alert.
              </Alert>
            ),
          }}
          sx={header?.sx}
        />
      }
      sidebarSection={<NavigationWidescreen breakpointFrom={layoutQuery} />}
      sx={{
        [`& .${layoutClasses.hasSidebar}`]: {
          [theme.breakpoints.up(layoutQuery)]: {
            pl: "var(--layout-nav-vertical-width)",
          },
        },
        ...sx,
      }}
    >
      <LayoutContent>{children}</LayoutContent>
    </LayoutSection>
  );
};
